(() => {
  const normalizeValue = (value) => String(value || '').trim().toLowerCase();

  const getSelection = (options, selected) => {
    const normalizedSelected = normalizeValue(selected);
    const selectedIndex = options.findIndex((option) => (
      normalizeValue(option.value || option.label) === normalizedSelected
    ));

    if (selectedIndex >= 0) return { activeIndexes: [selectedIndex], range: null };

    const range = normalizedSelected
      .split(/\s*[-–—]\s*/)
      .filter(Boolean);
    if (range.length !== 2) return { activeIndexes: [], range: null };

    const rangeIndexes = range.map((value) => options.findIndex((option) => (
      normalizeValue(option.value || option.label) === value
      || normalizeValue(option.label) === value
    )));
    if (rangeIndexes.some((index) => index < 0)) {
      return { activeIndexes: [], range: null };
    }

    return {
      activeIndexes: [],
      range: {
        start: Math.min(...rangeIndexes),
        end: Math.max(...rangeIndexes),
      },
    };
  };

  const renderCharacteristics = (root) => {
    if (!root || root.dataset.rendered === 'true') return;

    const data = root.querySelector('.metafield-json');
    if (!data) return;

    let characteristics;
    try {
      characteristics = JSON.parse(data.textContent || '[]');
    } catch (error) {
      return;
    }

    if (!Array.isArray(characteristics)) return;

    const classPrefix = root.classList.contains('fabric-care-characteristics')
      ? 'fabric-care-characteristics'
      : 'fabric-profile';
    const stats = document.createElement('div');
    stats.className = `${classPrefix}__stats`;

    characteristics.forEach((characteristic) => {
      const options = Array.isArray(characteristic.options) ? characteristic.options.slice(0, 3) : [];
      if (!characteristic.label || options.length === 0) return;

      const selection = getSelection(options, characteristic.selected);
      const stat = document.createElement('div');
      stat.className = `${classPrefix}__stat`;

      const title = document.createElement('h3');
      title.className = `${classPrefix}__stat-name`;
      title.textContent = characteristic.label;
      stat.appendChild(title);

      const bars = document.createElement('div');
      bars.className = `${classPrefix}__scale-bars`;
      if (selection.range) bars.classList.add('has-range');
      bars.setAttribute('role', 'img');
      bars.setAttribute('aria-label', `${characteristic.label}: ${characteristic.selected || ''}`);
      options.forEach((_option, index) => {
        const bar = document.createElement('span');
        if (selection.range) {
          if (index === selection.range.start) bar.className = 'is-range-start';
          if (index > selection.range.start && index < selection.range.end) {
            bar.className = 'is-range-middle';
          }
          if (index === selection.range.end) bar.className = 'is-range-end';
        } else if (selection.activeIndexes.includes(index)) {
          bar.className = 'is-active';
        }
        bars.appendChild(bar);
      });
      stat.appendChild(bars);

      const labels = document.createElement('div');
      labels.className = `${classPrefix}__scale-labels`;
      labels.setAttribute('aria-hidden', 'true');
      options.forEach((option, index) => {
        const label = document.createElement('span');
        label.textContent = option.label || option.value || '';
        if (index === 1) label.style.textAlign = 'center';
        if (index === 2) label.style.textAlign = 'right';
        labels.appendChild(label);
      });
      stat.appendChild(labels);
      stats.appendChild(stat);
    });

    root.replaceChildren(stats);
    root.dataset.rendered = 'true';
  };

  const initializeCharacteristics = () => {
    document.querySelectorAll('[data-fabric-characteristics]').forEach(renderCharacteristics);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCharacteristics, { once: true });
  } else {
    initializeCharacteristics();
  }

  document.addEventListener('shopify:section:load', initializeCharacteristics);
})();
